// src/pages/Support.js
import React from 'react';
import styled from 'styled-components';

const PageContainer = styled.div`
  padding-top: 80px;
  min-height: 100vh;
`;

const Support = () => {
  return (
    <PageContainer>
      <h1>Support</h1>
    </PageContainer>
  );
};

export default Support;